var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.practiceCourt.visible)?_c('div',[_c('Card',{attrs:{"content":_vm.content,"characters":_vm.characters,"label":_vm.content.type === 'desktop' ? '云桌面' : '练习'},on:{"clickCard":_vm.handleClick}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }